import { useContext } from 'react'

import { useCartSummaryQuery } from '@Generated/graphql'
import { MetadataContext } from '@Globals/Metadata'
import { Money } from '@Globals/Money'

export const useCheapestShippingPrice = () => {
  const { store } = useContext(MetadataContext)
  const { data, loading } = useCartSummaryQuery({
    context: {
      domainProxy: true,
      userSpecific: true,
    },
    fetchPolicy: 'cache-only',
    nextFetchPolicy: 'cache-only',
  })

  if (!loading && data?.cart?.freeShipping?.cheapest) {
    return data.cart.freeShipping.cheapest as Money
  }

  return store.config?.cheapestShippingPrice
}

export const useFreeShippingThreshold = () => {
  const { store } = useContext(MetadataContext)
  const { data, loading } = useCartSummaryQuery({
    context: {
      domainProxy: true,
      userSpecific: true,
    },
    fetchPolicy: 'cache-only',
    nextFetchPolicy: 'cache-only',
  })

  if (!loading && data?.cart?.freeShipping?.threshold) {
    return data.cart.freeShipping.threshold as Money
  }

  return store.config?.freeShippingThreshold
}

export const useFreeShippingThresholdClub = () => {
  const { store } = useContext(MetadataContext)
  return store.config?.freeShippingThresholdClub
}
